import { render } from "./YearStampIcon.vue?vue&type=template&id=643ab2bf"
import script from "./YearStampIcon.vue?vue&type=script&lang=js"
export * from "./YearStampIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__